// CSS Modules - component class name prefix: SocialSharing__

<template>
  <ul :class="[$style.container, 'column']">
    <li v-for="(link, index) in socialSharingLinks" :key="index">
      <SocialSharingLink :link="link" />
    </li>
  </ul>
</template>

<script>
import SocialSharingLink from "./SocialSharingLink.vue";

export default {
  name: "SocialSharing",
  components: {
    SocialSharingLink
  },
  props: {
    socialSharingLinks: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style module lang="scss">
  @import "./SocialSharing.scss";
</style>
